import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {FrontEndIcon, BackendIcon, EcommerceIcon , CloudIcon} from "../../../app-constants";

const StackItem = [
    {
        icon: FrontEndIcon,
        title: 'Frontend Development',
        description: 'WordPress, Drupal, Webflow, React, Angular, Bootstrap',
    },
    {
        icon: BackendIcon,
        title: 'Backend',
        description: 'PHP, Laravel, .NET Core, Scala, Ruby, Lua, Java, Sails, MySQL',
    },
    {
        icon: CloudIcon,
        title: 'Cloud Services',
        description: 'AWS Azure, Oracle Cloud, Google Cloud Platform',
    },
    {
        icon: EcommerceIcon,
        title: 'E-commerce Platforms',
        description: 'WooCommerce Shopify',
    }

];


function Technology(props) {
    return (
        <div className="technoloy_sec p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
                        <div className="example" data-text="Tech">
                            <h2>Technologies TekRevol Uses for Web Design & Development</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto offset-xl-1">
                        <p>As a professional web design and development company, we leverage the latest tools and technologies to meet each project's unique needs.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
                        <div className="technology_main">
                            {StackItem.map((item, index) => (
                                <div className="technology_item">
                                    <div className="svg_icon">
                                        {item.icon}
                                    </div>
                                    <h6>{item.title}</h6>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Technology;